export default {
    // 用户身份
    userTypeName(type) {
        return type ? '推广员' : '玩家'
    },
    getImage(img){
        //TODO-url
       return 'http://test.fs.pk.cc:8061'+img;
    },
    // 牌局类型
    roomTypeName(type) {
        switch (type) {
            case 61:
                type = '德州';
                break;
            case 62:
                type = '德州必下场';
                break;
            case 63:
                type = '德州-AOF';
                break;
            case 91:
                type = '奥马哈';
                break;
            case 92:
                type = '奥马哈必下场';
                break;
            case 93:
                type = '奥马哈-AOF';
                break;
            case 51:
                type = '大菠萝';
                break;
            case 71:
                type = 'MTT';
                break;
            case 81:
                type = 'SNG';
                break;
            default:
                break
        }
        return type
    },
    jackpotNumber(val){
        return val/100;
    },
    // 彩池类型
    jackpotTypeName(type) {
        switch (type) {
            case 1:
                type = '普通池';
                break;
            case 2:
                type = '奥马哈池';
                break;
            case 3:
                type = 'AOF池 ';
                break;
            default:
                break
        }
        return type;
    },
    // 击中牌型
    pocerTypeName(type) {
        switch (type) {
            case 1:
                type = '皇同';
                break;
            case 2:
                type = '同花顺';
                break;
            case 3:
                type = '四条';
                break;
            default:
                break;
        }
        return type;
    },
    // 俱乐部充值类型
    topUpTypeName(type) {
        return type ? '平台充值' : '俱乐部充值'
    },
    // 俱乐部关闭状态
    clubStatusName(type) {
        return type ? '关闭' : '正常'
    },
    // 俱乐部对赌仓状态
    clubConfigStatus(type) {
        return type ? '开启' : '关闭'
    },
    // 常用设备
    equipmentName(name) {
        return name === 'simulator' ? '模拟器' : name;
    },
    toTime(time, format = 'yyyy-MM-dd HH:mm:ss') {
        let date = new Date(time);
        let y = date.getFullYear();
        let M = date.getMonth() + 1;
        let d = date.getDate();
        M = M < 10 ? '0' + M : M;
        d = d < 10 ? '0' + d : d;
        if (format === 'yyyy-MM-dd') {
            return `${y}-${M}-${d}`
        }
        let H = date.getHours();
        let m = date.getMinutes();
        let s = date.getSeconds();
        H = H < 10 ? '0' + H : H;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        if (format === 'yyyy-MM-dd HH:mm:ss') {
            return `${y}-${M}-${d} ${H}:${m}:${s}`
        }

        return date.getTime();
    },
    // 数字的单位
    numberUnit(number) {
        if (number === '') return '--';
        let num = Math.abs(number), unit = '';
        if (num >= 100000000) {
            return '超出范围'
        } else if (num >= 10000000) {
            unit += '千万'
        } else if (num >= 1000000) {
            unit += '百万'
        } else if (num >= 100000) {
            unit += '十万'
        } else if (num >= 10000) {
            unit += '万'
        } else if (num >= 1000) {
            unit += '千'
        } else if (num >= 100) {
            unit += '百'
        } else if (num >= 10) {
            unit += '十'
        } else if (num > 0) {
            unit += '个'
        }
        return unit + (number > 0 ? '' : '（负）');
    },
    //数字的倍率转换
    numberChip(val){
        return val/100;
    },
    blindNoteNumber(val){
        const result=val.split("/");
        return result[0]/100+"/"+result[1]/100;
    },
    blindNoteNumber2(val){
        const result=val/100;
        return result+"/"+result*2;
    },
    getLocalTime(nS) {
        //将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
        let date = new Date(nS);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        month = month < 10 ? "0"+month:month;
        day = day < 10 ? "0"+day:day;
        date = year+'-'+month+'-'+day;
        return date;
    },
}